import { Component, OnInit, Input } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { ConfirmComponent } from '../../../shared/confirm/confirm.component';
import { BcAccountClientService } from '../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { BcApCtcSelectorComponent } from './bc-ap-ctc-selector/bc-ap-ctc-selector.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-bc-allowance-proposal',
  templateUrl: './bc-allowance-proposal.component.html',
  styleUrls: ['./bc-allowance-proposal.component.scss']
})
export class BcAllowanceProposalComponent implements OnInit {

  @Input("proposalID") proposalID;
  @Input("clientID") clientID;
  @Input("profileUser") profileUser;

  // LocalStorage
  private permissoes;
  private userID;

  //Data
  private proposalData;
  private reasonList;

  //Permission
  private canSave;
  private canSendToCommittee;
  private canSendToBilling;
  private canCancel;

  //Disabled Controls
  private disableReason = true;
  private disableConceptH = true;
  private disableCommercial = true;
  private disableBilling = true;

  //Route
  private routeSub;
  private idFromRoute;

  //First Load Control
  private proposalLoaded = false;

  public showLoader = false;

  constructor(private dialogService: DialogService,
    private bcAccountClientService: BcAccountClientService,
    private flashMessagesService: FlashMessagesService,
    private route: ActivatedRoute) { }

    ngOnInit() {

      this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
      this.userID = localStorage.getItem('yara.userID');

      this.routeSub = this.route.params.subscribe(params => {
        this.idFromRoute = params['id'];
      });

      console.log("SOCORRO");
      console.log(window.location.href.indexOf('proposta-abono').toString(), window.location.href.indexOf('proposta-abono').toString().length);
      if (window.location.href.indexOf('proposta-abono') != -1) {
        this.loadProposal();
      }

      // if (this.idFromRoute == this.proposalID){
      //   this.loadProposal();
      //   setTimeout(() => {
      //     $('html, body').animate({ scrollTop: $("#headingBCCliAllowance").offset().top - 20 }, 500)
      //   }, 300);
      // }
    }

    loadProposal(){
      if (!this.proposalLoaded){
        this.getProposalData(false);
        this.getReasonList();
        this.proposalLoaded = true;
      }
    }

    resetPermission() {
      this.canSave = false;
      this.canSendToCommittee = false;
      this.canSendToBilling = false;
      this.canCancel = false;

      this.disableReason = true;
      this.disableConceptH = true;
      this.disableCommercial = true;
      this.disableBilling = true;
    }

    verifyPermissions() {
      this.resetPermission();
      if (this.proposalData.PropostaCobrancaStatusID == "EC") {
        console.log("EM CRIACAO");
        if (this.profileUser == "Analista de Cobrança") {
          this.disableBilling = false;
          this.disableReason = false;
          this.disableConceptH = false;

          this.canSave = this.permissoes['Abono_Inserir'];
          this.canCancel = this.permissoes['Abono_Cancelar'];
          this.canSendToCommittee = this.permissoes['Abono_CobrancaComite'];
        }
        else if (this.profileUser == "Consultor Técnico Comercial") {
          if (this.userID == this.proposalData.ResponsavelID){
            this.disableCommercial = false;
            this.disableReason = false;
            this.disableConceptH = false;

            this.canSave = this.permissoes['Abono_Inserir'];
            this.canCancel = this.permissoes['Abono_Cancelar'];
            this.canSendToBilling = this.permissoes['Abono_Cobranca'];
          }
        }
      }
      else if (this.proposalData.PropostaCobrancaStatusID == "CC") {
        console.log("COBRANCA");
        if (this.profileUser == "Analista de Cobrança"){
          this.disableBilling = false;

          this.canSave = this.permissoes['Abono_Inserir'];
          this.canCancel = this.permissoes['Abono_Cancelar'];
          this.canSendToCommittee = this.permissoes['Abono_CobrancaComite'];
        }
      }
      else if (this.proposalData.PropostaCobrancaStatusID == "EA") {
        console.log("EM APROVACAO");
        if (this.profileUser == "Analista de Cobrança"){
          this.disableBilling = true;

          this.canCancel = this.permissoes['Abono_Cancelar'];
        }
      }
    }

    getProposalData(silent){
      this.bcAccountClientService.getAllowanceProposal(this.proposalID).subscribe(result => {
        if (result.Success) {
          if(!silent){
            this.flashMessagesService.show("Proposta de Abono carregada", { cssClass: 'alert-success', timeout: 6000 });
          }
          this.proposalData = result.Result;
          this.verifyPermissions();
          console.log("Proposta de Abono", this.proposalData);
          if (window.location.href.indexOf('proposta-abono') != -1) {
            $(".allowance-click").removeClass("collapsed").attr("aria-expanded", "true");
            $("#collapseBCCliAllowance").addClass("show");
            setTimeout(() => {
              $('html, body').animate({ scrollTop: $("#headingBCCliAllowance").offset().top - 20 }, 500);
            }, 1000);
          }
        } else {
          this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
        }
      }, error => {
        console.log(error);
      });
    }

    getReasonList(){
      this.bcAccountClientService.getReasonList().subscribe(result => {
        if (result.Success) {
          this.reasonList = result.Result;
        } else {
          this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
        }
      }, error => {
        console.log(error);
      });
    }

    onSave(silent){
      this.bcAccountClientService.saveAllowanceProposal(this.proposalData).subscribe(result => {
        if (result.Success) {
          if(!silent){
            this.flashMessagesService.show("Proposta salva com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
          }
          this.getProposalData(true);
        } else {
          this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
        }
      }, error => {
        console.log(error);
      });
    }

    onCancel(){
      var message = 'Confirma o encerramento da Proposta de Abono?'
      let disposable = this.dialogService.addDialog(ConfirmComponent, {
        title:'Confirmar Encerramento',
        message: message},
        { backdropColor: 'rgba(0, 0, 0, 0.5)' })
        .subscribe((isConfirmed)=>{
          //We get dialog result
          if(isConfirmed) {
          this.cancel();
        }
        else {
          //Do nothing here
        }
      });
      //Close dialog calling disposable.unsubscribe();
      //If dialog was not closed manually close it by timeout
      setTimeout(()=>{
      disposable.unsubscribe();
    },15000);
  }

  cancel(){
    this.bcAccountClientService.cancelAllowanceProposal(this.proposalID).subscribe(result => {
      if (result.Success) {
        this.bcAccountClientService.proposalChanged.next(true);
        this.bcAccountClientService.billingChaged.next(true);
        this.flashMessagesService.show("Proposta encerrada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  onSendToCommittee(){
    this.dialogService.addDialog(BcApCtcSelectorComponent, {
      clientID: this.clientID},
      { backdropColor: 'rgba(0, 0, 0, 0.5)' })
      .subscribe((result)=>{
        //We get dialog result
        if(result) {
        // this.onSave(true);
        const selectedCtcId = result.ctc;
        const commentary = result.commentary;
        this.sendToCommittee(selectedCtcId, commentary);
      }
      else {
        //Do nothing here
      }
    });
  }

  sendToCommittee(selectedCtcId, commentary){

    this.showLoader = true;

    this.bcAccountClientService.saveAllowanceProposal(this.proposalData).subscribe(result => {

      if (result.Success) {

        this.internalSending(selectedCtcId, commentary);

      } else {
        this.showLoader = false;
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      this.showLoader = false;
      console.log(error);
    });
  }

  internalSending(selectedCtcId, commentary) {

    const tempObj = {
      ContaClienteID: this.clientID,
      Motivo: commentary,
      CodigoSap: selectedCtcId,
      ID: this.proposalID
    }

    this.bcAccountClientService.sendAllowanceToCommittee(tempObj).subscribe(result => {

      this.showLoader = false;

      if (result.Success) {
        this.flashMessagesService.show("Proposta enviada para o Comitê.", { cssClass: 'alert-success', timeout: 6000 });
        this.getProposalData(true);
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {

      this.showLoader = false;
      console.log(error);

    });
  }

  onSendToBilling(){
    this.dialogService.addDialog(BcApCtcSelectorComponent, {
      clientID: this.clientID},
      { backdropColor: 'rgba(0, 0, 0, 0.5)' })
      .subscribe((result)=>{
        //We get dialog result
        if(result) {
        const selectedCtcId = result.ctc;
        const commentary = result.commentary;
        // this.onSave(true);
        this.sendToBilling(selectedCtcId, commentary);
      }
      else {
        //Do nothing here
      }
    });
  }

  sendToBilling(selectedCtcId, commentary){

    this.showLoader = true;

    this.bcAccountClientService.saveAllowanceProposal(this.proposalData).subscribe(result => {
      if (result.Success) {

        this.internalSendBilling(selectedCtcId, commentary);

      } else {
        this.showLoader = false;
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      this.showLoader = false;
      console.log(error);
    });

  }

  internalSendBilling(selectedCtcId, commentary) {
    const tempObj = {
      ContaClienteID: this.clientID,
      Motivo: commentary,
      CodigoSap: selectedCtcId,
      ID: this.proposalID
    }

    this.bcAccountClientService.sendAllowanceToBilling(tempObj).subscribe(result => {

      this.showLoader = false;

      if (result.Success) {
        this.flashMessagesService.show("Proposta enviada para Analista!", { cssClass: 'alert-success', timeout: 6000 });
        this.getProposalData(true);
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-success', timeout: 6000 });
      }
    }, error => {
      this.showLoader = false;
      console.log(error);
    });

  }



}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-allowance-proposal/bc-allowance-proposal.component.ts